import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useEffect, useState} from "react";
import useCustomTranslation from "core/customTranslation";
import {translations} from "../translations";
import ValuePreview from "components/ValuePreview";

const PreviewShip = ({show, item = {}}) => {
    const {t: tC} = useCustomTranslation(translations);
    const [formData, setFormData] = useState({...item});

    useEffect(() => {
        setFormData({...item});
    }, [item]);

    const values = formData.values || {};

    return (
        <div
            className={`col preview-row ${show ? "" : "d-none"}`}
            style={{width: "400px", maxWidth: "400px"}}>
            <div className="row">
                <div className="col-12 p-0">
                    <div className="preview-card border-start" style={{width: "400px"}}>
                        <div className="preview-header">
                            <div className="preview-icon">
                                <FontAwesomeIcon icon="fa-solid fa-wrench" />
                            </div>
                            <div className="preview-title">
                                <label>{tC("preview.add.ship")}</label>
                                <div>{formData.name}</div>
                            </div>
                        </div>
                        <div className="p-2">
                            <ValuePreview label={tC("field.name")} value={formData.name} />
                            <ValuePreview label={tC("field.model")} value={formData.model} />
                            <ValuePreview label={tC("field.start_hour")} value={values.h_start} />
                            <ValuePreview label={tC("field.minutes_between_measures")} value={values.min_measure} />
                            <ValuePreview label={tC("field.number_to_send")} value={values.num_pub ?? "-"} />
                            <ValuePreview label={tC("field.collected_measures")} value={values.num_measure || values.num_measures || "-"} />
                            <ValuePreview label={tC("field.minutes_between_measures_fl")} value={values.min_measure_b || "-"} />
                            <ValuePreview label={tC("field.publication_interval")} value={values.interval_send || "-"} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PreviewShip;
